export default __webpack_public_path__ + "static/louis-reed-pwcKF7L4-no-unsplash-d5bf23bbac546b23cf065b7338f3dfdb.jpg";